import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_branch_ext_RowClass} from '../../dbschema/bl_fi_mst_branch_ext.model';

export class BranchExtensionContainerModel extends BaseContainerModel {
  bl_fi_mst_branch_ext: bl_fi_mst_branch_ext_RowClass = new bl_fi_mst_branch_ext_RowClass();
}
